// Shared instrument picker options (mirrors the ear training activities).
// Keys map to soundfontInstruments entries; 'random' picks per play.
export function getInstrumentOptions(t) {
  return {
    random: { name: `🎲 ${t('earTraining.instruments.random')}`, soundfont: null },
    piano: { name: `🎹 ${t('earTraining.instruments.piano')}`, soundfont: 'piano' },
    electric_piano: { name: `🎹 ${t('earTraining.instruments.electricPiano')}`, soundfont: 'electric_piano' },
    guitar: { name: `🎸 ${t('earTraining.instruments.guitar')}`, soundfont: 'guitar' },
    bass: { name: `🎸 ${t('earTraining.instruments.bass')}`, soundfont: 'bass' },
    strings: { name: `🎻 ${t('earTraining.instruments.strings')}`, soundfont: 'strings' },
    violin: { name: `🎻 ${t('earTraining.instruments.violin')}`, soundfont: 'violin' },
    cello: { name: `🎻 ${t('earTraining.instruments.cello')}`, soundfont: 'cello' },
    brass: { name: `🎺 ${t('earTraining.instruments.brass')}`, soundfont: 'brass' },
    french_horn: { name: `🎺 ${t('earTraining.instruments.frenchHorn')}`, soundfont: 'french_horn' },
    trombone: { name: `🎺 ${t('earTraining.instruments.trombone')}`, soundfont: 'trombone' },
    saxophone: { name: `🎷 ${t('earTraining.instruments.saxophone')}`, soundfont: 'saxophone' },
    flute: { name: `🎵 ${t('earTraining.instruments.flute')}`, soundfont: 'flute' },
    clarinet: { name: `🎵 ${t('earTraining.instruments.clarinet')}`, soundfont: 'clarinet' },
    oboe: { name: `🎵 ${t('earTraining.instruments.oboe')}`, soundfont: 'oboe' },
    organ: { name: `🎼 ${t('earTraining.instruments.organ')}`, soundfont: 'organ' },
    choir: { name: `👥 ${t('earTraining.instruments.choir')}`, soundfont: 'choir' },
    bells: { name: `🔔 ${t('earTraining.instruments.bells')}`, soundfont: 'bells' },
    harp: { name: `🪕 ${t('earTraining.instruments.harp')}`, soundfont: 'harp' }
  };
}
